/* Father's Day sticky CTA bar.
   Loaded globally so it runs even when GemPages inserts the section's markup
   lazily / via innerHTML (where inline <script> tags never execute).
   Moves each bar to <body> (escaping GemPages wrappers that trap position:fixed),
   then shows it once the FIRST PDP is ~50% scrolled past the top of the viewport,
   and hides it again once the SECOND PDP scrolls into view. */
(function () {
  // --- tunables ---------------------------------------------------------------
  // Show once this fraction of the first PDP has scrolled above the top.
  var SHOW_AFTER_FIRST = 0.5;
  // Hide once the second PDP's top reaches this fraction of the viewport height
  // from the top (0 = its top hits the very top, 1 = the moment it peeks in at the
  // bottom). 0.5 = hide once the second PDP has risen to the middle of the screen.
  var HIDE_WHEN_SECOND_AT = 0.5;
  // ----------------------------------------------------------------------------

  function setup(bar) {
    if (bar.dataset.fdStickyInit) return;

    var id = bar.getAttribute('data-fd-id') || '';
    var sentinel = document.querySelector('[data-fd-sticky-sentinel="' + id + '"]');
    if (!sentinel) {
      // Sentinel not in the DOM yet (lazy GemPages insert) — retry on the next mutation.
      return;
    }
    bar.dataset.fdStickyInit = '1';

    // Escape any transformed/overflow GemPages wrapper that traps position:fixed.
    if (bar.parentNode !== document.body) {
      document.body.appendChild(bar);

      // Moving the bar disconnects + reconnects the theme's <product-form>. On
      // disconnect it removes its submit listener (BaseComponent.destroyListeners),
      // but on reconnect ProductForm.mountComponent is guarded by hasListenerAttached
      // (still true) and never re-attaches — so the form falls back to a native
      // submit (redirect) instead of AJAX add-to-cart. Re-arm it here. The old
      // listener is already gone, so this attaches exactly one (no double-add).
      var pf = bar.querySelector('product-form');
      if (pf && typeof pf.mountComponent === 'function') {
        pf.hasListenerAttached = false;
        try { pf.mountComponent(); } catch (e) {}
      }
    }

    function viewportH() {
      return window.innerHeight || document.documentElement.clientHeight;
    }

    // Measure the PDP sections directly so we can trigger at a fraction of the first:
    //   show  = first PDP is SHOW_AFTER_FIRST scrolled past the top
    //   hide  = second PDP has risen to HIDE_WHEN_SECOND_AT of the viewport
    // .fd-rpdp = v7 render snippet; .fd-pdp-section = section-based (main) PDP wrapper.
    // Fall back to the sentinel (end of the first PDP) if neither is present.
    function shouldShow() {
      var pdps = document.querySelectorAll('.fd-rpdp, .fd-pdp-section');
      if (pdps.length) {
        var first = pdps[0].getBoundingClientRect();
        if (!(first.height > 0 && first.top <= -(first.height * SHOW_AFTER_FIRST))) {
          return false;
        }
        if (pdps.length > 1) {
          var second = pdps[1].getBoundingClientRect();
          if (second.top < viewportH() * HIDE_WHEN_SECOND_AT) {
            return false; // going through the second PDP — hide
          }
        }
        return true;
      }
      return sentinel.getBoundingClientRect().top < 0;
    }

    var ticking = false;
    var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
    function update() {
      ticking = false;
      bar.classList.toggle('is-visible', shouldShow());
    }
    function onScroll() {
      if (!ticking) { ticking = true; raf(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function init() {
    var bars = document.querySelectorAll('.fd-sticky-cta[data-fd-id]');
    for (var i = 0; i < bars.length; i++) setup(bars[i]);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
  window.addEventListener('load', init);

  // Catch GemPages (and other) lazily-inserted instances.
  if ('MutationObserver' in window) {
    new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
